export const handleFaxNumberFormat = (_faxNumber: string): string => {
	const formatterFaxNumber: string =
		_faxNumber.substring(0, 3) + "-" + _faxNumber.substring(3, 6) + "-" + _faxNumber.substring(6);

	return formatterFaxNumber;
};
